export const SET_GLOBALFILTER_IDS = "SET_GLOBALFILTER_IDS";
export const SET_GLOBALFILTER_SAPCODE = "SET_GLOBALFILTER_SAPCODE";
export const SET_GLOBALRESETFILTER = "SET_GLOBALRESETFILTER";
